<template>
    <div class="handMenu">
        <el-card shadow="never" style="width:100%;border: 0;">
            <el-row>
                <el-col :lg="5" :xl="5">
                    <!-- 用来显示完整导航条 -->
                    <el-button round class="hidden-md-and-down" v-if="!this.$store.getters.getMenuIsCollapse"
                               @click="changeMenu"><i
                            class="el-icon-s-unfold"></i></el-button>
                    <!-- <el-button plain>朴素按钮</el-button> -->
                    <el-button round class="hidden-md-and-down" v-if="this.$store.getters.getMenuIsCollapse"
                               @click="changeMenu"><i
                            class="el-icon-s-fold"></i></el-button>
                </el-col>
                <!-- 搜索框	 -->
                <el-col :xs="24" :sm="18" :md="18" :lg="11" :xl="13">
                    <el-autocomplete style="width: 100%;border-radius: 25px;" class="inline-input"
                                     v-model="searchInput.state"
                                     :fetch-suggestions="querySearch" placeholder="Search" clearable
                                     prefix-icon="el-icon-search" :trigger-on-focus="false"
                                     @select="handleSelect" @keyup.enter.native="search()">
                    </el-autocomplete>
                </el-col>
                <!--标题右边的按钮-->
                <el-col class="hidden-xs-only" :sm="6" :md="6" :lg="8" :xl="6" style="text-align: right;">
                    <!-- 这个是打开抽屉的按钮 -->
                    <el-button icon="el-icon-receiving" type="primary" circle @click="openDrawer"/>
                    <!-- 这个是准备用来打开随手记的按钮 -->
                    <el-button icon="el-icon-edit" type="info" circle/>
                    <!-- 这个是用来打开日历的按钮 -->
                    <el-button icon="el-icon-date" @click="centerDialogVisible=true" type="warning"
                               circle/>
                    <!-- 弹出对话框 内容为日历 -->
                    <el-dialog width="50%" top="2vh" title="日历" :visible.sync="centerDialogVisible"
                               center>
                        <el-calendar v-model="nowTime">
                            <!-- 这个是日历-->
                        </el-calendar>
                    </el-dialog>
                </el-col>
                <el-drawer title="我是一个抽屉，但是还没想好放啥" :visible.sync="drawer" :with-header="false">
                    <!-- 这个是抽屉里的内容 待定 -->
                    <span>我来啦!</span>
                </el-drawer>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "HandMenu",
        data() {
            return {
                //待修改
                city: "福州",
                // 搜索框
                searchInput: {
                    state: ''
                },
                // 这个是抽屉
                drawer: false,
                // 这个是展示日历的对话框
                centerDialogVisible: false,
                // 这个是日历
                nowTime: new Date(),
            }
        },
        methods: {
            //修改导航条状态的方法
            changeMenu() {
                this.$store.commit("setMenuIsCollapse", !this.$store.getters.getMenuIsCollapse);
            },
            querySearch(queryString, cb) {
                var results = [];
                // 根据内容取百度获取关键字
                if (queryString != "") {
                    this.$http.jsonp("https://www.baidu.com/sugrec?pre=1&p=3&ie=utf-8&json=1&prod=pc&from=pc_web", {
                        params: {
                            wd: queryString
                        },
                        jsonp: 'cb' //jsonp默认是callback,百度缩写成了cb                   }
                    }).then(res => {
                        if (res.data.g) {
                            for (var i = 0; i < res.data.g.length; i++) {
                                results.push({
                                    value: res.data.g[i].q
                                })
                            }
                        }
                    });
                }
                // 调用 callback 返回建议列表的数据
                cb(results);
            },//这个是选择某个内容后执行
            handleSelect(item) {
                let url = "https://www.baidu.com/s?wd=" + item.value;
                window.open(url);
            },
            // 打开抽屉的方法
            openDrawer() {
                this.drawer = true;
            },
            // 搜索框的回车键监听
            search() {
                let url = "https://www.baidu.com/s?wd=" + this.searchInput.state;
                window.open(url);
            },
        },
    }
</script>

<style scoped>
    /* 修改输入框的弧度 */
    /deep/ .el-input__inner {
        border-radius: 25px;
    }
</style>